import comp from './StandardFilter';
export default comp;
